module.exports = __webpack_public_path__ + "img/RX-Arcos-3.5e1d624f.png";